<template>
  <loading-content
    :loading="loading"
    :error="error"
    :isTab="false">

    <v-form
      ref="form"
    >
      <v-text-field
        outline
        :disabled="cpfTouched || has_document || readonly"
        :background-color="cpfTouched || has_document || readonly ? '#ccc' : ''"
        v-model="attributes.document"
        :rules="readonly ? [] : [rules.required, rules.cpf]"
        mask="###.###.###-##"
        label="CPF"
      />

      <v-text-field
        outline
        :background-color="blockDueCpfSearch || readonly ? '#ccc' : ''"
        :disabled="blockDueCpfSearch || readonly"
        v-model="attributes.name"
        :rules="blockDueCpfSearch || readonly ? [] : [rules.required]"
        label="NOME DO RESPONSÁVEL/RESPONSIBLE NAME"
      />

      <v-layout row wrap>
        <v-flex d-flex xs12 sm6 md6>
          <v-text-field
            outline
            :background-color="blockDueCpfSearch || readonly ? '#ccc' : ''"
            :disabled="blockDueCpfSearch || readonly"
            v-model="birthday"
            :rules="[rules.date]"
            mask="##/##/####"
            return-masked-value
            placeholder="dd/mm/yyyy"
            label="DATA DE NASCIMENTO/DATE OF BIRTH"
          />
        </v-flex>

        <v-flex d-flex xs12 sm6 md6>
          <v-text-field
            outline
            :background-color="blockDueCpfSearch || readonly ? '#ccc' : ''"
            :disabled="blockDueCpfSearch || readonly"
            v-model="attributes.occupation"
            label="PROFISSÃO/OCUPATION"
          />
        </v-flex>
      </v-layout>

      <v-text-field
        outline
        :background-color="blockDueCpfSearch || readonly ? '#ccc' : ''"
        :disabled="blockDueCpfSearch || readonly"
        v-model="attributes.other_documents"
        label="R.G/PASSPORT NUMBER"
      />

      <v-text-field
        outline
        :background-color="blockDueCpfSearch || readonly ? '#ccc' : ''"
        :disabled="blockDueCpfSearch || readonly"
        v-model="attributes.address"
        label="ENDEREÇO COMPLETO/ADDRESS"
      />

      <v-layout row wrap>
        <v-flex d-flex xs12 sm6 md4>
          <v-text-field
            outline
            :background-color="blockDueCpfSearch || readonly ? '#ccc' : ''"
            :disabled="blockDueCpfSearch || readonly"
            v-model="attributes.number"
            label="NÚMERO/NUMBER"
          />
        </v-flex>

        <v-flex d-flex xs12 sm6 md4>
          <v-text-field
            outline
            :background-color="blockDueCpfSearch || readonly ? '#ccc' : ''"
            :disabled="blockDueCpfSearch || readonly"
            v-model="attributes.complement"
            label="COMPLEMENTO/COMPLEMENT"
          />
        </v-flex>

        <v-flex d-flex xs12 sm6 md4>
          <v-text-field
            outline
            :background-color="blockDueCpfSearch || readonly ? '#ccc' : ''"
            :disabled="blockDueCpfSearch || readonly"
            v-model="attributes.zip_code"
            label="CEP/ZIP CODE"
          />
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex d-flex xs12 sm6 md6>
          <v-text-field
            outline
            :background-color="blockDueCpfSearch || readonly ? '#ccc' : ''"
            :disabled="blockDueCpfSearch || readonly"
            v-model="attributes.mobile_phone"
            label="TELEFONE CELULAR/MOBILE PHONE"
          />
        </v-flex>

        <v-flex d-flex xs12 sm6 md6>
          <v-text-field
            outline
            :background-color="blockDueCpfSearch || readonly ? '#ccc' : ''"
            :disabled="blockDueCpfSearch || readonly"
            v-model="attributes.work_phone"
            label="TELEFONE COMERCIAL/WORK PHONE"
          />
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex d-flex xs12 sm6 md6>
          <v-text-field
            outline
            :background-color="blockDueCpfSearch || readonly ? '#ccc' : ''"
            :disabled="blockDueCpfSearch || readonly"
            v-model="attributes.home_phone"
            label="TELEFONE RESIDENCIAL/HOME PHONE"
          />
        </v-flex>

        <v-flex d-flex xs12 sm6 md6>
          <v-text-field
            outline
            :background-color="blockDueCpfSearch || readonly ? '#ccc' : ''"
            :disabled="blockDueCpfSearch || readonly"
            v-model="attributes.email"
            :rules="blockDueCpfSearch || readonly ? [] : [rules.required, rules.email]"
            label="E-MAIL"
          />
        </v-flex>
      </v-layout>

    </v-form>
  </loading-content>
</template>

<script>
import { formatDateToPtBR, formatDateToDbFormat } from '@/helpers/formatDbDate'
import { date as datePattern, email as emailPattern } from '@/helpers/regex'
import * as cpfValidation from '@/helpers/cpfValidation'
import * as api from '@/api'
import { nestedRegistry, formTabs } from '@/mixins'
import LoadingContent from '@/components/LoadingContent'

/**
 * @group Form
 * Componente de form para dados de responsavel
 */
export default {
  name: 'FormResponsible',

  components: {
    LoadingContent
  },

  props: {
    // id do responsavel
    responsible_id: {
      type: Number,
      default: null
    },

    // atributos do responsavel
    responsible_attributes: {
      type: Object,
      default: null
    },

    // controle de edição de todos os campos
    readonly: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    rules: {
      required: value => !!value || 'Campo obrigatório/Field is required',
      email: value => {
        return emailPattern.test(value) || 'Email inválido/Invalid e-mail.'
      },
      date: value => {
        return !value || datePattern.test(value) || 'Data inválida/Invalid date'
      },
      cpf: value => {
        return cpfValidation.validate(value || '') || 'CPF Inválido/CPF Invalid'
      }
    },
    cpfTouched: false,
    blockDueCpfSearch: true,
    has_document: false
  }),

  mixins: [nestedRegistry, formTabs],

  computed: {
    birthday: {
      get () {
        return formatDateToPtBR(this.attributes.birthday)
      },

      set (newValue) {
        this.attributes.birthday = formatDateToDbFormat(newValue)
      }
    },

    document () {
      return this.attributes.document
    },

    attributes: {
      get () {
        return this.form.responsible_attributes || {}
      },
      set (attributes) {
        this.form.responsible_attributes = attributes
      }
    }
  },

  mounted () {
    if (!this.readonly) {
      if (this.responsible_id) {
        api.responsible.parent.edit(this.currentStudentId, this.responsible_id)
          .then(({ data }) => {
            this.handleResponse({ data })
            if (this.attributes.document) this.has_document = true
            this.blockDueCpfSearch = false
          }).catch(this.handleError)
          .finally(this.handleFinally)
      } else {
        api.responsible.parent.getModel(this.currentStudentId)
          .then(this.handleResponse)
          .catch(this.handleError)
          .finally(this.handleFinally)
      }
    } else {
      this.readonlyLoad(this.responsible_attributes)
    }
  },

  methods: {
    /**
     * @vuese
     * Método responsavél pela ação de submit do formulário
     */
    save () {
      if (this.validateForm()) {
        this.$emit('responsible_attributes', this.form)
      }
    }
  },

  watch: {
    document (newValue) {
      if (newValue && cpfValidation.validate(newValue) && !this.readonly && !this.responsible_id) {
        api.responsible.getByDocument(newValue).then(({ data }) => {
          if (data) {
            this.attributes = data
            this.blockDueCpfSearch = false
            this.cpfTouched = true
          } else {
            this.blockDueCpfSearch = false
            this.cpfTouched = false
          }
        }).catch(error => {
          throw new Error(error)
        })
      }
    },

    responsible_attributes: {
      handler (newValue) {
        this.form = newValue
      },
      deep: true
    }
  }
}
</script>
